module.exports = __webpack_public_path__ + "assets/slike/pozadine/razrusen-grad-savremen.ae55b0fd51f032edf8cb627a1cc49b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/slike/pozadine/razrusen-grad-savremen.jpg
// module id = 35
// module chunks = 0